var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "GuardarButton",
    _vm._b(
      { on: { click: _vm.handleClick } },
      "GuardarButton",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    ),
    [_vm._v("\n  Guardar Cambios\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }